import { z } from "zod";

import { validHttpUrl } from "api/utils";
import { COUNTRY_VALUES, GREATER_REGION_VALUES, REGION_VALUES } from "domains/moderate/sources/constants";

export const sourceFormDataSchema = z.object({
  name: z.string().min(1),
  url: validHttpUrl(),
  description: z.string(),
  active: z.boolean(),
  logoUrl: z.string().optional(),
  license: z.object({ label: z.string(), value: z.string() }).optional(),
  autopilot: z.object({ label: z.string(), value: z.string().nullable() }).optional(),
  type: z.object({ label: z.string(), value: z.string() }).optional(),
  publicationType: z.object({ label: z.string(), value: z.string() }),
  contentType: z.object({ label: z.string(), value: z.string() }).optional(),
  country: z.object({ label: z.string(), value: z.enum(COUNTRY_VALUES) }).optional(),
  region: z.object({ label: z.string(), value: z.enum(REGION_VALUES) }).optional(),
  greaterRegion: z.object({ label: z.string(), value: z.enum(GREATER_REGION_VALUES) }).optional(),
});

export type SourceFormData = z.infer<typeof sourceFormDataSchema>;
